module.exports = __webpack_public_path__ + "static/icon-payment-d5529db01e6da6a81cb4d715d3df9c48.png";